function forceCartLink() {
  const cartIcon = document.getElementById("cart-icon-bubble");
  if (!cartIcon) return;

  // onclick 上書き（最優先）
  cartIcon.onclick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = cartIcon.getAttribute("href");
    return false;
  };

  // キャプチャ段階でクリックを強制
  cartIcon.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = cartIcon.getAttribute("href");
    },
    true
  );
}

// 初回
document.addEventListener("DOMContentLoaded", forceCartLink);

// PageFly や Ajax 再描画に対応
const observer = new MutationObserver(forceCartLink);
observer.observe(document.body, { childList: true, subtree: true });